import { render, staticRenderFns } from "./exchange_order.vue?vue&type=template&id=4afbeacc"
import script from "./exchange_order.vue?vue&type=script&lang=ts"
export * from "./exchange_order.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports